import Environment from '../config/Environment';
import Debug from './Debug';

export default class WebService {
    static getCheckoutData = (clientType, shoppingCart) => {
        const environment = Environment.database;
        const client = Environment.client;
        const url = `https://getcheckout-x3herayjcq-uc.a.run.app?environment=${environment}&client=${client}`;
        let body = shoppingCart.toCheckout();
        body.store_id = shoppingCart.store;
        body.external_sale_flow = false;
        body.is_client = clientType === 'client';
        return fetch(url, {method: 'POST', mode: 'cors', cache: 'no-cache', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(body)})
            .then(response => this.onResponse(response, true))
            .then(response => {
                if (response) {
                    const id = response['id'] || undefined;
                    const url = response['checkout_url'] || undefined;
                    const summary = response['checkout_summary'] || undefined;
                    if (!summary) throw new Error('Invalid checkout summary');
                    const method = summary['form']['method'] || undefined;
                    if (!method) throw new Error('Invalid checkout method');
                    const inputs = summary['form']['inputs'] || undefined;
                    if (!inputs || inputs.length !== 2) throw new Error('Invalid checkout inputs');
                    const type = response['details'] && response['details'] && response['details']['type'] ? response['details']['type'] : undefined;
                    const message = response['details'] && response['details'] && response['details']['message'] ? response['details']['message'] : undefined;
                    const status = response['details'] && response['details'] && response['details']['status'] ? response['details']['status'] : undefined;
                    const error = status ? {type: type, message: message, status: status} : undefined;
                    return {id, url, method, inputs, error};
                } else return undefined;
            })
            .catch((error) => {
                Debug.printToLog('error', error);
                return undefined;
            });
    };

    static onResponse = (response, parseErrors = false) => {
        if (response.ok || parseErrors) {
            try {
                return response.json();
            } catch (error) {
                Debug.printToLog('error', `Unable to parse JSON response for endpoint ${response.url}: ${error}`);
                return undefined;
            }
        } else {
            return undefined;
        }
    };
}